import Image from '@base/FutureImage';
import { segment } from '@actions/analytics';
import Link from '@base/Link/Link';
import P1 from '@base/P1/P1';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import styled from '@emotion/styled';
import { COURSE_CARD_CLICKED_EVENT, LESSON_HREF } from './constants';
import { convertTitleToSlug } from './utils';

const CourseCardContainer = styled.div`
  width: 267px;
  height: auto;
  margin: ${({ $isRenderedInCarousal }) =>
    $isRenderedInCarousal ? `${Spacings.SPACING_5}` : `${Spacings.SPACING_17}`};
  margin-left: ${Spacings.SPACING_0B};
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    min-width: 90vw;
    padding-right: ${({ $isRenderedInCarousal }) =>
      $isRenderedInCarousal
        ? `${Spacings.SPACING_10}`
        : `${Spacings.SPACING_0B}`};
    margin: ${({ $isRenderedInCarousal }) =>
        $isRenderedInCarousal
          ? `${Spacings.SPACING_0B}`
          : `${Spacings.SPACING_15}`}
      0px;
  }
`;

const CourseTopBar = styled.div`
  height: 2px;
  width: 198px;
  background-color: var(--color-i-divider);
  margin-bottom: ${Spacings.SPACING_3};
`;

const CourseDetailsContainer = styled.div`
  width: 100%;
`;

const CourseThumbnailWrapper = styled.div`
  position: relative;
  border-radius: ${Spacings.SPACING_2B};
  width: 267px;
  height: 150px;
  background-color: var(--color-i-divider);
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 210px;
  }
`;

const StyledImage = styled(Image)`
  height: 100%;
  width: 100%;
  border-radius: ${Spacings.SPACING_10};
`;

const CourseTitle = styled(P1)`
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  margin-top: ${Spacings.SPACING_10};
`;

const CourseLessonCount = styled(P1)`
  font-size: ${Fonts.P2};
  font-weight: ${Fonts.LIGHT};
  color: var(--color-i-gray-13);
`;

const CourseCard = ({ course, goalUID, carousalCard }) => {
  const courseSlug = course?.slug || convertTitleToSlug(course?.title);
  const targetURL = `/content/p/freecourses/${goalUID}/${courseSlug}/${course?.id}/-1`;
  const onCourseClick = () => {
    segment.track(COURSE_CARD_CLICKED_EVENT, {
      course_title: course?.title,
      goal_uid: goalUID
    });
  };

  return (
    <Link as={targetURL} href={LESSON_HREF} onClick={onCourseClick}>
      <CourseCardContainer $isRenderedInCarousal={carousalCard}>
        {!carousalCard && <CourseTopBar />}
        <CourseDetailsContainer>
          <CourseThumbnailWrapper>
            <StyledImage
              src={course?.courseThumbnail}
              alt="Course thumbnail"
              width={350}
            />
          </CourseThumbnailWrapper>
          <CourseTitle>{course?.title}</CourseTitle>
          {!carousalCard && (
            <CourseLessonCount>
              {course?.videoCount}{' '}
              {course?.videoCount === 1 ? 'Lesson' : 'Lessons'}
            </CourseLessonCount>
          )}
        </CourseDetailsContainer>
      </CourseCardContainer>
    </Link>
  );
};

export default CourseCard;
